// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Vant, { Toast } from 'vant'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueJsonp from 'vue-jsonp'
import moment from 'moment'
import axios from 'axios'


// 样式导入
import 'babel-polyfill'
import 'styles/reset.css'
import 'styles/border.css'
import 'styles/iconfont.css'
import 'swiper/dist/css/swiper.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'vant/lib/index.css'

// axios.defaults.xsrfHeaderName = 'X-CSRFToken';
// axios.defaults.xsrfCookieName = 'csrftoken';
Vue.prototype.$http = axios;
// 配置 Vue
Vue.config.productionTip = false
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$moment = moment

// 按顺序使用插件
Vue.use(ElementUI)
Vue.use(Vant)
Vue.prototype.$toast = Toast
window.Toast = Toast
Vue.use(VueAwesomeSwiper)
Vue.use(VueJsonp)

// 配置 axios
// axios.defaults.withCredentials = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js